import React, { FC, useState } from 'react';
import ActionButton from '~components/atoms/ActionButton';
import Modal from '~components/atoms/Modal';
import Table from '~components/molecules/Table';
import ViewSerialNoModalModal from '~components/molecules/ViewSerialNoModal';
import { useAppSelector } from '~redux/hooks';
import { MetalTypeEnum, TransactionActionEnum } from '~utils/enums';

type GoldTransactionItemsProps = {
    isOpen: boolean;
    onClose: () => void;
    isLoading: boolean;
}

const CustomerManagementTransactionProductDetailsTable: FC<GoldTransactionItemsProps> = ({ isOpen, onClose, isLoading }) => {
    const selectedTransaction = useAppSelector((state) => state.gold.buyAndSellGold.selectedTransaction);
    const discountList = useAppSelector((state) => state.setting.discounts.data);

    const [serialNoList, setSerialNoList] = useState<string[]>([]);
    const [isSerialNoModalOpen, setIsSerialNoModalOpen] = useState(false);

    const tableHeader = [
        'ID',
        'PRODUCT ID',
        'PRODUCT NAME',
        'DESCRIPTION',
        'AMOUNT',
        'PHYSICAL WEIGHT',
        'TOTAL WEIGHT',
        'PRICE',
        'SERIAL NO.',
        'DISCOUNT NAME',
        'DISCOUNT CODE',
        'DISCOUNT TYPE',
        'DISCOUNTED PRICE',
        'NET VALUE PER TRANSACTION ITEM',
    ];

    const tableBody = selectedTransaction?.items.map((item) => {
        const {
            customerTransactionItemId,
            productId,
            productName,
            description,
            amount,
            physicalGoldWeight,
            physicalSilverWeight,
            metalType,
            totalWeight,
            goldPrice,
            silverPrice,
            serialNo,
            discountName,
            discountCode,
            discountTransactionType,
            discountedPrice,
            netValuePerTransactionItem,
        } = item;

        const physicalWeight =
            metalType === MetalTypeEnum.Gold
                ? physicalGoldWeight
                : physicalSilverWeight;

        const price =
            metalType === MetalTypeEnum.Gold
                ? goldPrice
                : silverPrice;

        const handleViewSerialNo = () => {
            setIsSerialNoModalOpen(true);
            setSerialNoList(serialNo);
        };

        const renderSerialNo = () => {
            return (
                <ActionButton
                    testId='customer-details-transaction-view-serialNo-modal'
                    key={customerTransactionItemId}
                    label='View'
                    onClick={() => handleViewSerialNo()}
                />
            );
        };

        const getDiscountType = (discountType: TransactionActionEnum) => {
            if (discountType === TransactionActionEnum['Bank Sell']) {
                return (
                    <div>
                        <p>Discount</p>
                        <p>(Bank Sell)</p>
                    </div>
                );
            }

            if (discountType === TransactionActionEnum['Bank Buy']) {
                return (
                    <div>
                        <p>Markup</p>
                        <p>(Bank Buy)</p>
                    </div>
                );
            }
        };

        return [
            customerTransactionItemId,
            productId,
            productName,
            description,
            amount,
            physicalWeight || 'N/A',
            totalWeight,
            (Math.round(Number(price) * 100) / 100).toFixed(2),
            renderSerialNo(),
            discountName || '-',
            discountCode || '-',
            discountTransactionType ? getDiscountType(discountTransactionType) : '-',
            discountedPrice || '-',
            netValuePerTransactionItem ? `RM${(Math.round(Number(netValuePerTransactionItem) * 100) / 100).toFixed(2)}` : '-',
        ];
    }) || [];

    return (
        <Modal
            testId='customer-details-transaction-product-list-close'
            isOpen={isOpen}
            onClose={onClose}
            title='Transaction Product List'
        >
            <Table
                header={tableHeader}
                body={tableBody}
                isLoading={isLoading}
            />

            <ViewSerialNoModalModal
                isOpen={isSerialNoModalOpen}
                onClose={() => setIsSerialNoModalOpen(false)}
                serialNo={serialNoList}
            />
        </Modal>
    );
};

export default CustomerManagementTransactionProductDetailsTable;
